import React from "react"
import { graphql, StaticQuery } from "gatsby"

import Layout from "../components/Layout"
import SEO from "../components/SEO"

import Leader from "../components/Leader"
import LayoutBar from "../components/LayoutBar"
import BlogPost from "../components/BlogPost"


const Blog = () => {

    return (
        <Layout pageTitle="Blog">
            <SEO title="Blog" />
            <StaticQuery
                query={blogQuery}
                render={data => {
                return (

                    <div>
                        <Leader page="blog"/>
                        <LayoutBar page="blog"/>
                        <ol>
                            {data.allMarkdownRemark.edges.map(({ node },i) => (
                                <li>
                                    <BlogPost
                                        key={node.id}
                                        title={node.frontmatter.title}
                                        author={node.frontmatter.author}
                                        github={node.frontmatter.github}
                                        web={node.frontmatter.web}
                                        slug={node.fields.slug}
                                        date={node.frontmatter.date}
                                        body={node.excerpt}
                                        fluid={node.frontmatter.image.childImageSharp.fluid}
                                        order={node.frontmatter.order}
                                        tags={node.frontmatter.tags}
                                        time={node.timeToRead}
                                    />
                                </li>
                            ))}
                        </ol>
                    </div>
                )
            }}
        />
        </Layout>
    )
}

const blogQuery = graphql `
    query BlogQuery {
        allMarkdownRemark(
            sort:{fields: [frontmatter___order], order: DESC},
            filter:{frontmatter:{tags:{eq:"Blog"}}}
            )
        {
            totalCount
            edges {
                node {
                    id
                    timeToRead
                    frontmatter {
                        title
                        tags
                        author
                        github
                        web
                        order
                        date(formatString: "MMM do YYYY")
                        image {
                            childImageSharp {
                                fluid(grayscale: false, maxHeight: 260, webpQuality: 80, toFormat: WEBP) {
                                    ...GatsbyImageSharpFluid
                                    ...GatsbyImageSharpFluidLimitPresentationSize
                                }
                            }
                        }
                    }
                    fields{
                        slug
                    }
                    excerpt
                }
            }
        }
    }
`

export default Blog